module.exports = __webpack_public_path__ + "assets/img/icon-logo-3.9e2fbefe.png";